
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="5">
                <label for="select-empresa">Empresa</label>  
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                <label for="select-garagem_sol">Filial</label> 
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final" placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

            <b-col cols=1 class="mt-4">
                    
          <b-button size="sm" id="btn-pesquisar" variant="success" block class="mr-2 mt-1 "  @click="loadKpiDia(),loadKpiFilial(),loadKpiSolicitacapChassi(),loadKpiCarro(),loadKpiAbastecedor(),loadKpiResumo()">
              <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Filtrar gráfico
          </b-button>
              </b-col>

          </b-row>
    </b-form>   

    <div>
      <b-row>
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

            

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="CONSUMO DIESEL"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                                      
                  {{  (kpiresumo.reduce((total, item) => total + parseFloat(item.combustivel), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
                  </h2>
                </b-card-text>
              </b-card>
            

            
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="ÓLEO REPOSIÇÃO CONSUMO"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{  (kpiresumo.reduce((total, item) => total + parseFloat(item.reposicao), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
                </h2>
                
                
              </b-card-text>
            </b-card>



            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="ARLA CONSUMO"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{  (kpiresumo.reduce((total, item) => total + parseFloat(item.arla), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
                </h2>
                
              </b-card-text>
      </b-card>        

      

          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="KM RODADO"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{  (kpiresumo.reduce((total, item) => total + parseFloat(item.km_rodado), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
              </h2>
              
            </b-card-text>
          </b-card>



          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="MÉDIA KM/LITROS"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{ ( (kpiresumo.reduce((total, item) => total + parseFloat(item.km_rodado), 0)) / (kpiresumo.reduce((total, item) => total + parseFloat(item.combustivel), 0))  ).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
              </h2>
              
            </b-card-text>
          </b-card>

</b-card-group> 
      </b-row>
      
    </div>

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  

          <b-col cols="12" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>
        </b-row>

        <!-- acumulado  -->
        <b-row>

          <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts 
              ref="chart"
              height="400" 
              :options="graficoPizzaFilial"   
              :series ="graficoPizzaFilial.series"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

          <!-- acumulado  Chassi -->
          <b-col cols="3">
            <apexcharts 
            ref="chartChassi"
            height="400" :options="graficoChassi" 
            :series="seriesChassi"></apexcharts>
          </b-col>

          <!-- acumulado  Carro -->
          <b-col cols="3">
            <apexcharts
            ref="chartCarro" 
            height="400" 
            :options="graficoFuncioanrio" 
            :series="seriesCarro"
            ></apexcharts>
          </b-col>

          <!-- acumulado  Abastecedor -->
          <b-col cols="3">
            <apexcharts
            ref="chartAbastecedor" 
            height="400" 
            :options="graficoAbastecedor" 
            :series="seriesAbastecedor"
            ></apexcharts>
          </b-col>
        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'AbastecimentoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false                
              },
              
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Abastecimento diários',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    },
    
  },
  

  /* filial */  
  graficoPizzaFilial: {
          chart: {
            id: 'pizza-filial',             
            type: 'pie', 
            height: 350,                                      
            foreColor:"black",                         
          },
          labels: [],
          legend: {
            show: true,             
            position: 'bottom',
          },
          title: {
            text: 'Abastecimento por filial',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '22px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          }
  },

  /* Chassi */
  graficoChassi: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {
        horizontal: true,
        //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Abastecimento por chassi',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


   


/* Carro    */
  graficoFuncioanrio: {
    chart: {
              id: 'bar-Carro',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 10 por carro',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  
/* Abastecedor    */
  graficoAbastecedor: {
    chart: {
              id: 'bar-Carro',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 10 por abastecedor',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },



    

/* objetos */
  kpiresumo:[],
  kpifiliais:[],  
  kpidias:[],  
  kpiCarro:[] ,
  kpiAbastecedor:[] ,
  kpiChassi:[],
  dt_inicial: '',
  dt_final: '',  
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesdia:[],
  seriesfilial:[],  
  seriesCarro:[],
  seriesAbastecedor:[],
  seriesChassi:[],
  empresa:{}, 
  empresas:[],   // [] lista       
  filial:{}, 
  filiais: [],   // [] lista   
  sinistros:[],
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {     
      
        async loadKpiResumo() {
          let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                                                   
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
          };
          const url = `${baseApiUrl}/indicadores/abastecimento/resumo`
          axios.post(url,corpo)
            .then(res => {
              this.kpiresumo = res.data                              
            })
            .catch(showError)
      },

      /// filtros por filial
      async loadKpiFilial() {
          let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                                                   
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
          };
          const url = `${baseApiUrl}/indicadores/abastecimento/filial`
          axios.post(url,corpo)
            .then(res => {
              this.kpifiliais = res.data                
              this.updateChartDataFilial();              
            })
            .catch(showError)
      },

      async updateChartDataFilial() {                                                      
            this.graficoPizzaFilial.series = this.kpifiliais.map(item => parseInt(item.qtd));
            this.atualizarLabels()
      },

      async atualizarLabels() {
        this.graficoPizzaFilial.labels = await this.kpifiliais.map(item => item.filial);        
        this.$refs.chart.updateOptions({ labels: this.graficoPizzaFilial.labels });              
      },

      /// filtros por dia 
      async loadKpiDia() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                                           
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
            };
          const url = await `${baseApiUrl}/indicadores/abastecimento/periodo`
          axios.post(url,corpo)
            .then(res => {              
            this.kpidias = res.data 
            this.updateChartDataDia();               
            })
            .catch(showError)
    },
    
    async updateChartDataDia() {
      this.seriesdia = [{
        name: 'Qtd abastecimento',
        data: this.kpidias.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        categories: this.kpidias.map(d => d.dt_visualizacao)
      }  });       
    },

    /// filtros por Carro  21/08/2023
      async loadKpiCarro() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                                            
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
            };
          const url = await `${baseApiUrl}/indicadores/abastecimento/carro`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiCarro = res.data 
            this.updateChartDataCarro();               
            })
            .catch(showError)
    },
    
    async updateChartDataCarro() {
      this.seriesCarro = [{
        name: 'litros abastecidos',
        data: this.kpiCarro.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartCarro.updateOptions({ xaxis:{
        categories: this.kpiCarro.map(r => r.prefixo)
      }  });       
    },



 /// filtros por abastecedor 10/03/2024 - 22:03h
      async loadKpiAbastecedor() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                                            
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
            };
          const url = await `${baseApiUrl}/indicadores/abastecimento/abastecedor`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiAbastecedor = res.data 
            this.updateChartDataAbastecedor();               
            })
            .catch(showError)
    },
    
    async updateChartDataAbastecedor() {
      this.seriesAbastecedor = [{
        name: 'litros abastecidos',
        data: this.kpiAbastecedor.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartAbastecedor.updateOptions({ xaxis:{
        categories: this.kpiAbastecedor.map(r => r.abastecedor_re)
      }  });       
    },

/// filtros por Chassi tipo solicitação  21/08/2023
      async loadKpiSolicitacapChassi() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "id_filial": `${this.value_filial.map(f => f.id_filial_erp)}`,                        
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
            };
          const url = await `${baseApiUrl}/indicadores/abastecimento/chassi`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiChassi = res.data 
            this.updateKpiSolicitacaoChassi();               
            })
            .catch(showError)
    },
    
    async updateKpiSolicitacaoChassi() {
      this.seriesChassi = [{
        name: 'litros abastecido',
        data: this.kpiChassi.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartChassi.updateOptions({ xaxis:{
        categories: this.kpiChassi.map(d => d.chassi)
      }  });       
    },

    loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
    },  
      
    loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
    },
        
       
    loadPermissao() {
            let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,          
                         "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                           
            };

          const url = `${baseApiUrl}/sac/permissao`
          axios.post(url,{params}).then(res => {
            this.permissoes = res.data.map(permissao => {              
               return { ... permissao, id_area: permissao.id_area}
            })
            //this.loadSacSinistros()
            
          })
    },

    loadSacSinistros() {
            let corpo = {                    
                "id_empresa": `${this.value_empresa.map(e => e.id_empresa)}`,                     
                "id_filial": `${[this.value_filial.map(a => a.id_filial_erp)]}`,                                             
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            }; 
            const url = `${baseApiUrl}/indicadores/sinistro`            
            axios.post(url,corpo)
                  .then(res => {              
                  this.sinistros = res.data                      
                  })
                  .catch(showError)
                            
    },



    },

    created(){
      this.loadPermissao()           
    },



    mounted(){
        this.loadEmpresas()                                        
        this.loadGaragens()     
        this.loadKpiResumo()
        
        },
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>